import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';

export const RESET_PASSWORD = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`;

export const useResetPasswordMutation = () => {
  const [
    resetPassword,
    {
      loading: resetPasswordLoading,
      error: resetPasswordError,
      data: resetPasswordData,
    },
  ] = useMutation(RESET_PASSWORD);

  return {
    resetPassword,
    resetPasswordLoading,
    resetPasswordError,
    resetPasswordData,
  };
};
